import { connect } from 'react-redux';

import Component from './Component';

import runAnalysis from '../../actions/query-api/run-analysis';

const mapStateToProps = state => ({
  compareMode: state.entry.compareMode,
  investmentGoal: state.entry.original.investmentGoal,
  TEXT: state.complianceText,
});

const mapDispatchToProps = dispatch => ({
  setInvestmentGoal: value => dispatch({ type: 'SET_INVESTMENT_GOAL', value }),
  runAnalysis: () => dispatch(runAnalysis()),
  setAwaitingNewData: value => dispatch({ type: "SET_AWAIT_STATUS", status: value })
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);


// WEBPACK FOOTER //
// ./src/components/KeyMetrics/index.js